class TH_JSFunction {
    constructor(object) {
        this._function = object.function;
        this.parameters = object.parameters;
        this.return = object.return;

        this.function = null;
    }

    /** Wrap the static data of the JSFunction to an anonymous function
     * 
     * @returns function (returns an anonymous function)
     */
    wrapInFunction(instance) {
        let selfRef = this;

        this.function = function() {
            let result,
                originalArguments = Array.prototype.slice.call(arguments),
                original = this;

            if (typeof original.original != 'undefined') original = original.original;
            
            result = selfRef._function.apply({
                original: original,
                instance: instance
            }, originalArguments.concat(selfRef.parameters));

            if (selfRef.return) return result;
        }

        return this.function;
    }

    /** Fetch an object and create a JS function object from it if possible or return false, if it is not a valid JSFunction object
     * 
     * @param object object     (a JSFunction object, creatable on the back-end with \Facade\JSFunction)
     * @param object instance   (the instance on which to wrap this JSFunction)
     * 
     * @returns TH_JSFunction
     */
    static create(object, instance) {
        let _defaultStructure = ['function', 'parameters', 'return'];

        if (!utils.default.isObject(object)) {
            console.error("JS Function excepts an object as it's first parameter. You can create these objects with the \\Facade\\JSFunction class on server side!", object);
            return false;
        }

        for (let i in _defaultStructure) {
            if (typeof object[_defaultStructure[i]] == 'undefined') {
                console.error("Invalid JSFunction object structure received. You can create valid objects with the \\Facade\\JSFunction class on server side!", object);
                return false;
            }
        }

        if (typeof object.function != 'function') {
            object.function = utils.default.getFunction(object.function);
            if (typeof object.function != 'function') {
                console.error("Can't convert the string version of the function, to a valid javascript function!", object);
                return false;
            }
        }

        return new TH_JSFunction(object).wrapInFunction(instance);
    }
}

export default TH_JSFunction;